import { t, exists} from "../../i18n";

interface SwiftXException {
    errorCode: string;
    messageKey: string;
    message: string;
    details: Record<string, string>;
}

interface ParseExceptionResult {
    title: string | null;
    message: string | null;
}

export const parseSwiftXException = (error?: SwiftXException): ParseExceptionResult => {
    let title = null;
    let message = null;
    if (error) {
        const details = error.details || {};
        const titleKey = `${error.messageKey}.title`;
        if (exists(titleKey, details)) {
            title = t(titleKey, details);
        }

        let messageKey = `${error.messageKey}.message`;
        if (exists(messageKey, details)) {
            message = t(messageKey, details);
        } else if (exists(error.messageKey, details)) {
            message = t(error.messageKey, details);
        } 
    }
    return {
        title: title,
        message: message
    }
};

export default SwiftXException;